import type { RefObject } from 'react';

import type { ImageLike } from 'src/modules/renderings/imageLike';
import type { Rendering } from 'src/modules/renderings/types';
import type { FeatureTracking } from 'src/shared/constants/FeatureFlag';
import type {
  HiDefRendering,
  HiDefRenderingFile,
  Job,
  JobSharedRenderings,
} from 'src/shared/graphql/generated';

interface FocusedViewContext {
  isFocusedView: boolean;
  setIsFocusedView: (bool: boolean) => void;
  toggleFocusedView: () => void;
}

interface HeaderPortalContext {
  ref: RefObject<HTMLDivElement>;
}

interface CommonRenderingTrackingProperties {
  feature?: FeatureTracking;
  org_id?: number;
  job_id?: number;
  rendering_id?: number;
  partner_id?: number;
}

interface RenderingContext {
  renderings: Rendering[];
  images: ImageLike[];
  isCaptureRequest: boolean;
  address?: string;
  jobName?: string;
  job?: Job | JobSharedRenderings;
  orgLogoUrl?: string;
  orgName?: string;
  orgId?: number;
  partnerId?: number;
  userId?: number;
  jobId?: number;
  trackingData: CommonRenderingTrackingProperties;
  error?: boolean;
}

interface RenderingSelectionContext {
  rendering?: HiDefRendering;
  setRendering: (rendering?: HiDefRendering) => void;
  renderingFile?: HiDefRenderingFile;
  setRenderingFile: (renderingFile?: HiDefRenderingFile) => void;
}

const initialContext = {
  renderings: [],
  images: [],
  isCaptureRequest: false,
  trackingData: {},
};

export {
  RenderingContext,
  RenderingSelectionContext,
  FocusedViewContext,
  HeaderPortalContext,
  initialContext,
};
